/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignLaunchLaunch } from '../../axios/campaignLaunchLaunch'
import type {
	CampaignLaunchLaunchError,
	CampaignLaunchLaunchPathParams,
	CampaignLaunchLaunchRequest,
	CampaignLaunchLaunchResponse,
} from '../../types/CampaignLaunchLaunch'

export const campaignLaunchLaunchMutationKey = () => [{ url: '/campaigns/:campaign/launch' }] as const

export type CampaignLaunchLaunchMutationKey = ReturnType<typeof campaignLaunchLaunchMutationKey>

export type CampaignLaunchLaunchVariables = {
	campaign: CampaignLaunchLaunchPathParams['campaign']
	data: CampaignLaunchLaunchRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignLaunchController.php CampaignLaunchController::launch */
export function useCampaignLaunchLaunch<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignLaunchLaunchResponse,
		AxiosError<CampaignLaunchLaunchError>,
		CampaignLaunchLaunchVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignLaunchLaunchMutationKey(),
		mutationFn: ({ campaign, data }: CampaignLaunchLaunchVariables) =>
			campaignLaunchLaunch(campaign, data, config).then(res => res.data),
		...options,
	})
}
